/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';

/**
 * 
 * @export
 * @interface LeadDiagnosis
 */
export interface LeadDiagnosis {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    source: LeadDiagnosisSourceEnum;
    /**
     * 
     */
    is_primary: boolean;
    /**
     * 
     */
    is_snf_primary_ineligible: boolean;
    /**
     * 
     */
    code?: string;
    /**
     * 
     */
    short_description?: string;
    /**
     * 
     */
    long_description?: string;
    /**
     * 
     */
    onset_date?: string;
    /**
     * 
     */
    resolved_date?: string;
    /**
     * 
     */
    additional_information?: string;
    /**
     * 
     */
    visual_references?: Array<VisualReference>;
}


/**
 * @export
 */
export const LeadDiagnosisSourceEnum = {
    AiExtracted: 'ai_extracted',
    ReferralPlatformProvided: 'referral_platform_provided',
    UserAdded: 'user_added',
} as const;
export type LeadDiagnosisSourceEnum = typeof LeadDiagnosisSourceEnum[keyof typeof LeadDiagnosisSourceEnum];


/**
 * Check if a given object implements the LeadDiagnosis interface.
 */
export function instanceOfLeadDiagnosis(value: object): value is LeadDiagnosis {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('is_primary' in value) || value['is_primary'] === undefined) return false;
    if (!('is_snf_primary_ineligible' in value) || value['is_snf_primary_ineligible'] === undefined) return false;
    return true;
}

export function LeadDiagnosisFromJSON(json: any): LeadDiagnosis {
    return LeadDiagnosisFromJSONTyped(json, false);
}

export function LeadDiagnosisFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDiagnosis {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
        'is_primary': json['is_primary'],
        'is_snf_primary_ineligible': json['is_snf_primary_ineligible'],
        'code': json['code'] == null ? undefined : json['code'],
        'short_description': json['short_description'] == null ? undefined : json['short_description'],
        'long_description': json['long_description'] == null ? undefined : json['long_description'],
        'onset_date': json['onset_date'] == null ? undefined : json['onset_date'],
        'resolved_date': json['resolved_date'] == null ? undefined : json['resolved_date'],
        'additional_information': json['additional_information'] == null ? undefined : json['additional_information'],
        'visual_references': json['visual_references'] == null ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function LeadDiagnosisToJSON(json: any): LeadDiagnosis {
    return LeadDiagnosisToJSONTyped(json, false);
}

export function LeadDiagnosisToJSONTyped(value?: LeadDiagnosis | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'source': value['source'],
        'is_primary': value['is_primary'],
        'is_snf_primary_ineligible': value['is_snf_primary_ineligible'],
        'code': value['code'],
        'short_description': value['short_description'],
        'long_description': value['long_description'],
        'onset_date': value['onset_date'],
        'resolved_date': value['resolved_date'],
        'additional_information': value['additional_information'],
        'visual_references': value['visual_references'] == null ? undefined : ((value['visual_references'] as Array<any>).map(VisualReferenceToJSON)),
    };
}

